var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ShiftIntervalCategory } from '@amzn/atoz-shiftapp-types';
import { DateTime } from 'luxon';
export var useDesiredShiftIntervals = function (_a) {
    var shiftIntervals = _a.shiftIntervals, _b = _a.filterWorkIntervals, filterWorkIntervals = _b === void 0 ? false : _b, _c = _a.hideIntervalSkill, hideIntervalSkill = _c === void 0 ? false : _c;
    var sortedDesiredIntervals = React.useMemo(function () {
        var filteredIntervals = filterWorkIntervals
            ? shiftIntervals.filter(function (interval) { return interval.category !== ShiftIntervalCategory.Work; })
            : shiftIntervals;
        var mappedIntervals = hideIntervalSkill
            ? filteredIntervals.map(function (interval) { return (__assign(__assign({}, interval), { skill: null })); })
            : filteredIntervals;
        return mappedIntervals
            .slice()
            .sort(function (intervalA, intervalB) {
            return DateTime.fromISO(intervalA.timeRange.start).toMillis() -
                DateTime.fromISO(intervalB.timeRange.start).toMillis();
        });
    }, [shiftIntervals, filterWorkIntervals, hideIntervalSkill]);
    return sortedDesiredIntervals;
};
